import { createTeamspeakUI, TeamspeakUI } from './teamspeakUI';
import { Loader } from '../gamecloud/submodules/loader/loader';
import { Confirm } from '../confirm/confirm';
import { ITeamspeakComplain } from './interface';
import { Server } from '../units/server/server';
import ServerOptions = Server.ServerOptions;
import VoiceServerQueryResponse = Server.VoiceServerQueryResponse;
import ServerEvent = Server.ServerEventType;
import { API } from '../api/api';
import { Dialog } from '../dialog/dialog';

class Teamspeak {
    public loader: Loader = new Loader();

    constructor(private ui: TeamspeakUI) {
        this.bindEvents();
    }

    private bindEvents() {
        this.ui.onSaveButtonClick(this.saveSettings.bind(this));
        this.ui.onGenerateTokenButtonClick(this.generateToken.bind(this));
        this.ui.onDeleteTokenButtonClick(Teamspeak.deleteToken.bind(this));
        this.ui.onGenerateBackupButtonClick(Teamspeak.generateBackup.bind(this));
        this.ui.onDeleteBackupButtonClick(Teamspeak.deleteBackup.bind(this));
        this.ui.onApplyBackupButtonClick(this.applyBackup.bind(this));
        this.ui.onResetSettingsButtonClick(Teamspeak.resetSettings.bind(this));
        this.ui.onDeleteBanButtonClick(Teamspeak.deleteBan.bind(this));
        this.ui.onDeleteComplainButtonClick(Teamspeak.deleteComplain.bind(this));
        this.ui.onStatusButtonClick(Teamspeak.changeStatus.bind(this));
        this.ui.onCopyAdressButtonClick();
        this.ui.onTsdnsChange();

        window.addEventListener(Server.ServerEventType.GAMESERVERQUERY_EVENT, (event: CustomEvent<any>) => {
            let server = window.getServers().filter((item) => item.serverId === window.serverUnitSelectedId);
            if (server.length) {
                server[0].options = new ServerOptions(true, 3000);
                server[0].options.queryEvent.addEventListener(ServerEvent.SERVERQUERY_EVENT, (queryResponse: Promise<VoiceServerQueryResponse>) => {
                    queryResponse.then((queryResponse: VoiceServerQueryResponse) => {
                        this.ui.updateQueryInfo(queryResponse);
                    });
                });
            }
        });
    }

    private static changeStatus() {
        API.post('changeState', true);
    }

    private static resetSettings() {
        API.post('resetTSPermissions');
    }

    private saveSettings() {
        API.post('saveSettings', false, this.ui.getConfigurationValues());
    }

    private generateToken() {
        API.post('generateToken', true, this.ui.getSelectedTokenGroup());
    }

    private static deleteToken(token: string) {
        const bodyFormData = new FormData();
        bodyFormData.append('token', token);
        API.post('deleteToken', true, bodyFormData);
    }

    private static generateBackup() {
        API.post('generateBackup', true);
    }

    private static deleteBackup(id: string) {
      new Dialog()
        .withIcon('trash-alt')
        .withText('Do you really want to delete the backup?')
        .withTitle('Are you sure?')
        .withConfirmButtonText('Confirm')
        .withCenteredContent()
        .withOnConfirm(() => {
          const bodyFormData = new FormData();
          bodyFormData.append('id', id);

          API.post('deleteBackup', true, bodyFormData);
        })
        .render()

    }

    private applyBackup(id: string) {
      new Dialog()
        .withIcon('cloud-upload-alt')
        .withText('Do you really want to restore the backup?')
        .withTitle('Are you sure?')
        .withConfirmButtonText('Confirm')
        .withCenteredContent()
        .withOnConfirm(() => {
          const bodyFormData = new FormData();
          bodyFormData.append('id', id);
          API.post('applyBackup', true, bodyFormData);
        })
        .render()
    }

    private static deleteBan(id: string) {
        const bodyFormData = new FormData();
        bodyFormData.append('id', id);

        API.post('deleteBan', true, bodyFormData);
    }

    private static deleteComplain(complain: ITeamspeakComplain) {
        const bodyFormData = new FormData();
        bodyFormData.append('tcldbid', complain.tcldbid);
        bodyFormData.append('fcldbid', complain.fcldbid);

        API.post('deleteComplain', true, bodyFormData);
    }
}

export function initTeamspeak() {
    return createTeamspeakUI().map((ui: TeamspeakUI) => {
        return new Teamspeak(ui);
    });
}
